import { render, staticRenderFns } from "./App.vue?vue&type=template&id=ba35f6ec&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=ba35f6ec&prod&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports